import {closeModal, openModal} from "./utils/common";

const sizeTable = () => {
  const sizeTableBtnElement = document.querySelector(`.js-table-btn`);
  const tableContainerElement = document.querySelector(`.js-table-container`);

  if (tableContainerElement && sizeTableBtnElement) {
    const tableFormElement = tableContainerElement.querySelector(`.js-table-form`);
    const tableBodyElement = tableContainerElement.querySelector(`.js-table-body`);
    const imgElement = tableContainerElement.querySelector(`.js-table-img`);
    const closeBtnElement = tableContainerElement.querySelector(`.js-close`);
    const tableRows = tableBodyElement.querySelectorAll(`tr`);

    const imgFileName = {
      female: `sizes-female`,
      male: `sizes-male`,
    };

    function getRequiredPath(gender) {
      return `/img/size-table/${imgFileName[gender]}.svg`;
    }

    function onFormElementChange(evt) {
      const target = evt.target;

      changeTableRows(target.dataset.gender);
      changeImgPath(target.dataset.gender);
    }

    function changeTableRows(gender) {
      tableRows.forEach((item) => {
        if (item.dataset.gender === gender) {
          item.classList.remove(`table__row--hidden`);
        } else {
          item.classList.add(`table__row--hidden`);
        }
      });
    }

    function changeImgPath(gender) {
      imgElement.src = getRequiredPath(gender);
    }

    function showPopup() {
      openModal(tableContainerElement, `flex`);

      document.body.classList.add(`js-overflow`);

      tableFormElement.addEventListener(`change`, onFormElementChange);
      closeBtnElement.addEventListener(`click`, onCloseBtnElementClick);
    }

    function onCloseBtnElementClick() {
      hidePopup();
    }

    function hidePopup() {
      closeModal(tableContainerElement);

      document.body.classList.remove(`js-overflow`);

      tableFormElement.removeEventListener(`change`, onFormElementChange);
      closeBtnElement.removeEventListener(`click`, onCloseBtnElementClick);
    }

    function onBtnElementClick() {
      showPopup();
    }

    sizeTableBtnElement.addEventListener(`click`, onBtnElementClick);
  }
};

export {sizeTable};
